export default {
  title: 'FormationColHtmlConfig',
  description: 'Allows custom HTML',
  extends: 'FormationColConfig',
  structure: [
    {
      path: 'value',
      type: 'String',
      description: 'Custom HTML'
    }
  ]
}



/** WEBPACK FOOTER **
 ** ./src/docs/formationColHtmlConfig.js
 **/